import React from 'react';
import PT from 'prop-types';
import { Menu } from 'semantic-ui-react';
import { FilterMenuOptionsType } from '../../../lib/proptypes/semantic';
import classes from './buttonMenu.css';

const ButtonMenu = ({
  label,
  choices,
  activeItem,
  onChange,
  className,
  disabled,
  variableWidth,
  fixedWidthMenu,
}) => (
  <div className={className}>
    <div className={classes.labelText}> {label} </div>
    <Menu fluid widths={variableWidth ? null : choices.length} className={fixedWidthMenu ? classes.fixedWidthMenu : classes.filterMenu}>
      {choices.map(({ name, value }) => (
        <Menu.Item
          key={value}
          value={value}
          className={classes.textStyle}
          disabled={disabled}
          active={activeItem === value}
          onClick={onChange}
          style={variableWidth ? { } : { flex: 1 }}
        >
          {name}
        </Menu.Item>
      ))}
    </Menu>
  </div>
);

ButtonMenu.propTypes = {
  label: PT.string,
  activeItem: PT.oneOfType([PT.string, PT.number]), // Matches item.value in choices array
  className: PT.string,
  choices: FilterMenuOptionsType.isRequired,
  onChange: PT.func,
  disabled: PT.bool,
  variableWidth: PT.bool,
  fixedWidthMenu: PT.bool,
};

ButtonMenu.defaultProps = {
  label: '',
  className: null,
  activeItem: null,
  onChange: () => true,
  disabled: false,
  variableWidth: false,
  fixedWidthMenu: false,
};

export default ButtonMenu;



// WEBPACK FOOTER //
// ./src/app/components/FilterComponents/ButtonMenu.js